import { render } from "./CategorySection.vue?vue&type=template&id=f8a5af34&scoped=true"
import script from "./CategorySection.vue?vue&type=script&lang=js"
export * from "./CategorySection.vue?vue&type=script&lang=js"

import "./CategorySection.vue?vue&type=style&index=0&id=f8a5af34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a5af34"]])

export default __exports__